import { Components, Theme } from "@mui/material";

export const MuiAccordionSummary: Components<
  Omit<Theme, "components">
>["MuiAccordionSummary"] = {
  styleOverrides: {
    root: {},
  },
};
